module.exports = __webpack_public_path__ + "static/media/majorE3.47af1a5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorE3.wav
// module id = M4Nm
// module chunks = 0